// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import request from '@/api/request';

/**
 * @description 配置分类 -- 编辑表单
 */
export function updateConfigClassifyTable(id: number | string) {
  return request({
    url: `config/classify/update/table/${id}`,
    method: 'get',
  });
}

/**
 * @description 配置分类 -- 添加表单
 */
export function createConfigClassifyTable() {
  return request({
    url: 'config/classify/create/table',
    method: 'get',
  });
}

/**
 * @description 配置分类 -- 列表
 */
export function configClassifyLst(page: number, limit: number) {
  return request({
    url: 'config/classify/lst',
    method: 'get',
    params: { page, limit },
  });
}

/**
 * @description 配置分类 -- 修改状态
 */
export function changeConfigClassifyStatus(id: number | string, status: number) {
  return request({
    url: `group/data/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 配置分类 -- 删除
 */
export function classifyDelApi(id: number | string) {
  return request({
    url: `config/classify/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 配置 -- 删除
 */
export function settingDelApi(id: number | string) {
  return request({
    url: `config/setting/delete/${id}`,
    method: 'delete',
  });
}

export function updateConfigSettingTable(id: number | string) {
  return request({
    url: `config/setting/update/table/${id}`,
    method: 'get',
  });
}

export function createConfigSettingTable() {
  return request({
    url: 'config/setting/create/table',
    method: 'get',
  });
}

export function configSettingLst(page: number, limit: number) {
  return request({
    url: 'config/setting/lst',
    method: 'get',
    params: { page, limit },
  });
}

export function changeConfigSettingStatus(id: number | string, status: number) {
  return request({
    url: `config/setting/status/${id}`,
    method: 'post',
    data: { status },
  });
}

export function groupLst(page: number, limit: number) {
  return request({
    url: 'group/lst',
    method: 'get',
    params: { page, limit },
  });
}

export function createGroupTable() {
  return request({
    url: 'group/create/table',
    method: 'get',
  });
}

export function updateGroupTable(id: number | string) {
  return request({
    url: `group/update/table/${id}`,
    method: 'get',
  });
}

/**
 * @description 专题详情 -- 表格表头
 */
export function groupDetail(id: number | string) {
  return request({
    url: `group/detail/${id}`,
    method: 'get',
  });
}

/**
 * @description 专题列表 -- 列表
 */
export function groupDataLst(groupId: number | string, page: number, limit: number) {
  return request({
    url: `group/data/lst/${groupId}`,
    method: 'get',
    params: { page, limit },
  });
}

/**
 * @description 专题列表 -- 新增表单
 */
export function createGroupData(groupId: number | string) {
  return request({
    url: `group/data/create/table/${groupId}`,
    method: 'get',
  });
}

/**
 * @description 专题列表 -- 编辑表单
 */
export function updateGroupData(groupId: number | string, id: number | string) {
  return request({
    url: `group/data/update/table/${groupId}/${id}`,
    method: 'get',
  });
}

/**
 * @description 客服管理 -- 修改状态
 */
export function goupDataStatusApi(id: number | string, status: number) {
  return request({
    url: `/group/data/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 专题列表 -- 删除
 */
export function deleteGroupData(id: number | string) {
  return request({
    url: `group/data/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 菜单管理 -- 列表
 */
export function menuListApi(data: any) {
  return request({
    url: 'system/menu/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 菜单管理 -- 新增表单
 */
export function menuCreateApi() {
  return request({
    url: 'system/menu/create/form',
    method: 'get',
  });
}

/**
 * @description 菜单管理 -- 编辑表单
 */
export function menuUpdateApi(id: number | string) {
  return request({
    url: `system/menu/update/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 菜单管理 -- 删除
 */
export function menuDeleteApi(id: number | string) {
  return request({
    url: `system/menu/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 附件分类 -- 所有分类
 */
export function formatLstApi() {
  return request({
    url: 'system/attachment/category/formatLst',
    method: 'get',
  });
}

/**
 * @description 附件分类 -- 添加分类
 */
export function attachmentCreateApi() {
  return request({
    url: 'system/attachment/category/create/form',
    method: 'get',
  });
}

/**
 * @description 附件分类 -- 编辑分类
 */
export function attachmentUpdateApi(id: number | string) {
  return request({
    url: `system/attachment/category/update/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 附件分类 -- 编辑名称
 */
export function picNameUpdateApi(id: number | string, data: any) {
  return request({
    url: `system/attachment/update/${id}/form`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 附件分类 -- 编辑名称升级
 */
export function picNameEditApi(id: number | string, data: any) {
  return request({
    url: `system/attachment/update/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 附件分类 -- 删除分类
 */
export function attachmentDeleteApi(id: number | string) {
  return request({
    url: `system/attachment/category/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 图片列表
 */
export function attachmentListApi(data: any) {
  return request({
    url: 'system/attachment/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 素材管理-上传视频临时密钥
 * TITA：走 system/attachment/temp_key（素材列表权限），不走商品 store/product/temp_key
 */
export function attachmentGetTempKeysApi() {
  return request({
    url: 'system/attachment/temp_key',
    method: 'get',
  });
}

/**
 * @description 图片列表 -- 删除
 */
export function picDeleteApi(data:any) {
  return request({
    url: 'system/attachment/delete',
    method: 'delete',
    data: data,
  });
}

/**
 * @description 图片列表 -- 修改附件分类
 */
export function categoryApi(ids: any, attachmentCategoryId: number | string) {
  return request({
    url: 'system/attachment/category',
    method: 'post',
    data: { ids, attachmentCategoryId },
  });
}

/**
 * @description 客服管理 -- 创建表单
 */
export function serviceCreateApi() {
  return request({
    url: 'service/create/form',
    method: 'get',
  });
}

/**
 * @description 客服管理 -- 编辑表单
 */
export function serviceUpdateApi(id: number | string) {
  return request({
    url: `service/update/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 客服管理 -- 列表
 */
export function serviceListApi(data: any) {
  return request({
    url: 'service/list',
    method: 'get',
    params: data,
  });
}

/**
 * @description 客服管理 -- 修改状态
 */
export function serviceStatusApi(id: number | string, status: number) {
  return request({
    url: `service/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 客服管理 -- 删除
 */
export function serviceDeleteApi(id: number | string) {
  return request({
    url: `service/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 客服管理 -- 用户列表
 */
export function userLstApi(data: any) {
  return request({
    url: 'user/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 客服管理 -- 用户列表
 */
export function userListApi(data: any) {
  return request({
    url: 'user/list',
    method: 'get',
    params: data,
  });
}

/**
 * @description 客服管理 -- 用户列表
 */
export function serviceChatListApi(id: number | string, data: any) {
  return request({
    url: `service/${id}/user`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 客服管理 -- 客服与用户的聊天记录
 */
export function serviceChatUidListApi(id: number | string, uid: number | string, data: any) {
  return request({
    url: `service/${id}/${uid}/lst`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 客服管理 -- 登录
 */
export function serviceLoginApi(id: number | string) {
  return request({
    url: `service/login/${id}`,
    method: 'post',
  });
}

/**
 * @description 站内消息 -- 列表
 */
export function stationNewsList(data: any) {
  return request({
    url: 'notice/lst',
    method: 'get',
    params: data,
  });
}
/**
 * @description 站内消息 -- 删除
 */
export function delNoticeApi(id:number) {
  return request({
    url: `notice/del/${id}`,
    method: 'delete',
  });
}

/**
 * @description 站内消息 -- 详情
 */
export function noticeDetailApi(id:number) {
  return request({
    url: `notice/detail/${id}`,
    method: 'get',
  });
}


/**
 * @description 消息提示 -- 待办
 */
export function needDealtList() {
  return request({
    url: 'statistics/get_merchant_todo',
    method: 'get',
  });
}

/**
 * @description 站内消息列表 -- 设为已读
 */
export function stationNoticeRead(id: number | string) {
  return request({
    url: `notice/read/${id}`,
    method: 'post',
  });
}

/**
 * @description 消息 -- 未读数量
 */
export function unreadCountApi() {
  return request({
    url: 'notice/unread_count',
    method: 'get',
  });
}

/**
 * @description 设置 -- 电商服务申请
 */
export function createApplyment(data: any) {
  return request({
    url: 'applyments/create',
    method: 'post',
    data,
  });
}

/**
 * @description 设置 -- 分账接口版本
 */
export function applymentIndexApi() {
  return request({
    url: 'applyments/index',
    method: 'get',
  });
}

/**
 * @description 设置 -- 电商服务详情
 */
export function applymentDetail() {
  return request({
    url: 'applyments/detail',
    method: 'get',
  });
}

/**
 * @description 设置 -- 电商服务编辑
 */
export function updateApplyment(id: number | string, data: any) {
  return request({
    url: `applyments/update/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 设置 -- 分账列表
 */
export function applymentLstApi(data: any) {
  return request({
    url: 'profitsharing/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 设置 -- 物流公司列表
 */
export function expressLst(data: any) {
  return request({
    url: 'expr/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 设置 -- 物流公司列表
 */
export function accountUpdate(id: number | string) {
  return request({
    url: `expr/partner/${id}/form`,
    method: 'get',
  });
}

/**
 * @description 物流公司 -- 修改开启状态
 */
export function expressStatuseApi(id: number | string, data: any) {
  return request({
    url: `expr/changeMerStatus/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 分账管理 -- 导出
 */
export function ledgerManageExportApi(data: any) {
  return request({
    url: 'profitsharing/export',
    method: 'get',
    params: data,
  });
}

/**
 * @description 滑块 -- 请求滑块验证码
 */
export function ajCaptcha(data: any) {
  return request({
    url: 'ajcaptcha',
    method: 'get',
    params: data,
  });
}

/**
 * @description 滑块 -- 请求滑块验证码
 */
export function ajCaptchaCheck(data: any) {
  return request({
    url: 'ajcheck',
    method: 'post',
    data,
  });
}

/**
 * @description 滑块 -- 请求滑块验证码
 */
export function ajCaptchaStatus(data: any) {
  return request({
    url: 'ajstatus',
    method: 'post',
    data,
  });
}

/**
 * @description 专题活动 -- 创建
 */
export function topicCreate(id: number | string, data: any) {
  return request({
    url: `group/data/create/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 专题活动 -- 编辑
 */
export function topicUpdate(id: number | string, groupDataId: number | string, data: any) {
  return request({
    url: `group/data/update/${id}/${groupDataId}`,
    method: 'post',
    data,
  });
}

/**
 * @description 专题活动 -- 详情
 */
export function topicDetail(id: number | string) {
  return request({
    url: `group/data/detail/${id}`,
    method: 'get',
  });
}

/**
 * @description 菜单搜索 -- 获取数据
 */
export function getMenuSearchList(data: any) {
  return request({
    url: 'getMerchantMenusList',
    method: 'post',
    data,
  });
}

/**
 * @description 员工管理 -- 创建表单
 */
export function staffCreateApi() {
  return request({
    url: 'staffs/create/form',
    method: 'get',
  });
}

/**
 * @description 员工管理 -- 编辑表单
 */
export function staffUpdateApi(id: number | string) {
  return request({
    url: `staffs/update/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 员工管理 -- 列表
 */
export function staffListApi(data: any) {
  return request({
    url: 'staffs/list',
    method: 'get',
    params: data,
  });
}

/**
 * @description 员工管理 -- 修改状态
 */
export function staffStatusApi(id: number | string, status: number) {
  return request({
    url: `staffs/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 员工管理 -- 删除
 */
export function staffDeleteApi(id: number | string) {
  return request({
    url: `staffs/delete/${id}`,
    method: 'delete',
  });
}



/**
 * @description 员工管理 -- 统计列表
 */
export function staffStatisticsListApi(data: any) {
  return request({
    url: `staffs/statisticsList`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 员工管理 -- 统计详情
 */
export function staffStatisticsDetailApi(id:number) {
  return request({
    url: `staffs/statisticsDetail/${id}`,
    method: 'get',
  });
}


/**
 * @description 申请分账服务 -- 获取银行列表
 */
export function applymentBanksApi(params:any) {
  return request({
    url: `applyments/banks`,
    method: 'get',
    params,
  });
}

/**
 * @description 申请分账服务 -- 查询支行城市编码
 */
export function applymentBankCityCode(params:any) {
  return request({
    url:`applyments/areas`,
    method: 'get',
    params,
  });
}

/**
 * @description 申请分账服务 -- 获取银行支行列表
 */
export function applymentBankBranchesApi(params:any) {
  return request({
    url: `applyments/banks/branches`,
    method: 'get',
    params,
  });
}

/**
 * @description 申请分账服务 -- 创建特约商户
 */
export function applymentCreateApi(data: any) {
  return request({
    url: `applyments/create`,
    method: 'post',
     data,
  });
}

/**
 * @description 申请分账服务 -- 编辑特约商户
 */
export function applymentUpdateApi(id:number, data: any) {
  return request({
    url: `applyments/update/${id}`,
    method: 'post',
    data,
  });
}
